export const PUBLIC_ROUTES = [
	`${process.env.REACT_APP_API_BASE_URL}countries/${process.env.REACT_APP_VERSION_TAG}/list/`,
	`${process.env.REACT_APP_API_BASE_URL}crops/${process.env.REACT_APP_VERSION_TAG}/list/`,
	`${process.env.REACT_APP_API_BASE_URL}languages/${process.env.REACT_APP_VERSION_TAG}/list/`,
	`${process.env.REACT_APP_API_BASE_URL}specialties/${process.env.REACT_APP_VERSION_TAG}/`,
	`${process.env.REACT_APP_API_BASE_URL}irrigation-types/${process.env.REACT_APP_VERSION_TAG}/list/`,
	`${process.env.REACT_APP_API_BASE_URL}auth/${process.env.REACT_APP_VERSION_TAG}/staff/respond-to-deactivate-account`,
	`${process.env.REACT_APP_API_BASE_URL}auth/${process.env.REACT_APP_VERSION_TAG}/forgot-password`,
];
